export default __webpack_public_path__ + "static/media/moderntrade.dbd75d4d.png";